import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

/**
 * Confirms removing a team. Soft delete (docs/features/teams.md §4.3): ties record the team
 * they were booked for and every rubber reservation carries `teamid`, so a hard delete would
 * leave both pointing at nothing.
 *
 * What it does NOT do is unbook anything. Ties already booked keep their courts, exactly as
 * closing a season's booking window leaves existing reservations alone - a venue tidying up
 * their team list must not be able to empty the calendar by accident. The wording says so,
 * because "poista" reads like it should cancel the bookings too.
 */
function TeamDeleteDialog({ open, name, tiecount, onCancel, onConfirm, working }) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth='sm' fullWidth>
      <DialogTitle>Poistetaanko joukkue?</DialogTitle>
      <DialogContent>
        <Typography variant='body1' gutterBottom>
          <b>{name || ''}</b>
        </Typography>
        <Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
          Joukkue poistuu listalta eikä sen joukkueenjohtaja voi enää varata sille kohtaamisia.
          Jo varatut vuorot jäävät voimaan — tämä ei peru yhtään varausta.
        </Typography>
        {tiecount ? (
          <Typography variant='body2' color='warning.main' sx={{ mt: 1 }}>
            Joukkueella on {tiecount} kohtaamista. Peru ne erikseen, jos kentät on tarkoitus
            vapauttaa.
          </Typography>
        ) : null}
        <Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
          Jos joukkue on vain tauolla, merkitse se mieluummin tauolle muokkausnäkymässä — silloin
          se säilyy listalla ja historia pysyy luettavana.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={working}>
          Peruuta
        </Button>
        <Button onClick={onConfirm} variant='contained' color='error' disabled={working}>
          {working ? 'Poistetaan...' : 'Poista'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default TeamDeleteDialog
